(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-overview/assets/javascripts/coupon-overview.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-overview/assets/javascripts/coupon-overview.js');
"use strict";

const useCouponId = svs.components.tipsen.couponId.useCouponId;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const clx = svs.components.lbUtils.clx;
const _svs$components$tipse = svs.components.tipsen.engine.selectors.couponSelectors,
  selectPrice = _svs$components$tipse.selectPrice,
  selectSystemType = _svs$components$tipse.selectSystemType,
  selectRSystem = _svs$components$tipse.selectRSystem,
  selectUSystem = _svs$components$tipse.selectUSystem;
const _svs$components$tipse2 = svs.components.tipsen.engine.constants.systems,
  SYSTEM_REDUCERA_FRITT = _svs$components$tipse2.SYSTEM_REDUCERA_FRITT,
  SYSTEM_RSYS = _svs$components$tipse2.SYSTEM_RSYS,
  SYSTEM_USYS = _svs$components$tipse2.SYSTEM_USYS;
const getSystemLabelFromNumber = svs.components.sport.systems.getSystemLabelFromNumber;
const _svs$components$tipse3 = svs.components.tipsen.couponOverviewParts,
  CouponOverviewHeader = _svs$components$tipse3.CouponOverviewHeader,
  useOverviewFooter = _svs$components$tipse3.useOverviewFooter;
const Coupon = svs.components.tipsen.couponComponents.Coupon;
const useComponentFromRegistry = svs.components.tipsen.componentRegistry.useComponentFromRegistry;
const ShareCoupon = svs.components.tipsen.shareCoupon.ShareCoupon;
const CouponOverview = _ref => {
  var _svs$core$config$data, _svs$core$config$data2;
  let _ref$isCompact = _ref.isCompact,
    isCompact = _ref$isCompact === void 0 ? false : _ref$isCompact;
  const couponId = useCouponId();
  const price = useSelector(state => selectPrice(state, couponId));
  const systemType = useSelector(state => selectSystemType(state, couponId));
  const rSystem = useSelector(state => selectRSystem(state, couponId));
  const uSystem = useSelector(state => selectUSystem(state, couponId));
  const systemNum = {
    [SYSTEM_RSYS]: rSystem,
    [SYSTEM_USYS]: uSystem
  }[systemType];
  let systemLabel = 'M-system';
  if (systemNum) {
    systemLabel = getSystemLabelFromNumber(systemNum);
  } else if (systemType === SYSTEM_REDUCERA_FRITT) {
    systemLabel = 'Reducera fritt';
  }

  const CouponOverviewSelector = useComponentFromRegistry('coupon-overview-selector');
  const OverviewFooter = useOverviewFooter(systemType);
  const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
  const showShareCoupon = systemType !== SYSTEM_REDUCERA_FRITT && !isSelfService && !isCompact;
  const isReduceFree = systemType === SYSTEM_REDUCERA_FRITT;
  const blockName = 'pg_coupon_overview';
  const classNames = clx(blockName, {
    ["".concat(blockName, "--compact")]: isCompact,
    ["".concat(blockName, "--reduce-free")]: isReduceFree
  });
  return React.createElement("div", {
    className: classNames
  }, !isCompact && React.createElement(CouponOverviewHeader, {
    systemType: systemType
  }), React.createElement(Coupon, null, React.createElement(CouponOverviewSelector, {
    isCompact: isCompact
  })), !isCompact && React.createElement(OverviewFooter, {
    price: price,
    system: systemLabel
  }), showShareCoupon && React.createElement("div", {
    className: "margin-xs-h-2"
  }, React.createElement(ShareCoupon, {
    className: "margin-top-1"
  })));
};
setGlobal('svs.components.tipsen.couponOverview.CouponOverview', CouponOverview);

 })(window);